module.exports = __webpack_public_path__ + "static/media/5.70edc33f.png";